import * as React from 'react'
import { maskPhoneNumber } from '../../../utils/mask'

interface IMaskedPhoneNumberInputProps {
  onChange: (e: React.ChangeEvent<any>) => void
  onBlur: (e: any) => void
  value: any
  name: string
}

const MaskedPhoneNumberInput = (props: IMaskedPhoneNumberInputProps) => {
  const { value, onChange, ...rest } = props

  const onChangeHandler = (e: React.ChangeEvent<any>) => {
    if (maskPhoneNumber(e.target.value) !== value) {
      onChange(e)
    }
  }
  return <input type='text' {...rest} onChange={onChangeHandler} value={maskPhoneNumber(value)} />
}

export default MaskedPhoneNumberInput



// WEBPACK FOOTER //
// ./src/components/ui/formik/MaskedPhoneNumberInput.tsx